module.exports = __webpack_public_path__ + "static/img/system_02.c7a645b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system_02.png
// module id = JedW
// module chunks = 1